<template>
  <div class="shipping-information mt-5 lg:mt-10">
    <the-section :title="$t('ec-line005.shippingInformation.title')">
      <div class="el-form el-form--label-top">
        <span v-if="!isLogin">
          <span v-if="!hide_shipping_area">
            <card-item
              :label="$t('common.label.shippingAddressCard')"
              :value="data.delivery_destinations_text"
            ></card-item>
            <card-item :label="formLabelName" :value="Utils.helper.fullName(data.name01, data.name02)"></card-item>
            <card-item
              v-if="data.kana01"
              :label="formLabelNameKana"
              :value="Utils.helper.fullName(data.kana01, data.kana02)"
            ></card-item>
            <card-item :label="$t('common.memberInformation.address')">
              <div class="text-address">
                <p class="text-gray-950 text-base lg:text-lg break-all">
                  {{ Utils.helper.postalCode(data.postal_code01, data.postal_code02) }}
                </p>
                <p class="text-gray-950 text-base lg:text-lg break-all">
                  {{ Utils.helper.address(data.prefecture, data.addr01, data.addr02, '') }}
                </p>
                <p class="text-gray-950 text-base lg:text-lg break-all">
                  {{ data.addr03 }}
                </p>
              </div>
            </card-item>
            <card-item :label="$t('common.memberInformation.phoneNumber')" :value="data.phone_number"></card-item>
          </span>
        </span>
        <card-item v-else :label="$t('common.label.shippingAddressCard')">
          <card-item
            :label="$t('common.label.shippingAddressCard')"
            :value="data.delivery_destinations_text"
          ></card-item>
          <address-info-item
            :full-name="Utils.helper.fullName(data.name01, data.name02)"
            :postal-code="Utils.helper.postalCode(data.postal_code01, data.postal_code02)"
            :address="Utils.helper.address(data.prefecture, data.addr01, data.addr02, '')"
            :building-name="data.addr03"
          ></address-info-item>
        </card-item>
        <card-item :label="$t('common.label.shippingMethod')">
          <p :class="{ 'pdl-14': isLogin }">{{ data.shipping_method }}</p>
        </card-item>
        <card-item :label="$t('common.label.desiredDeliveryDay')">
          <p :class="{ 'pdl-14': isLogin }">{{ data.delivery_date }}</p>
        </card-item>
        <template>
          <card-item v-if="!data.time_note_disable_flag" :label="$t('common.label.desiredDeliveryTime')">
            <p :class="{ 'pdl-14': isLogin }">{{ data.delivery_time }}</p>
          </card-item>
          <card-item v-if="!data.time_note_disable_flag" :label="$t('common.label.specifyDeliveryNote')">
            <p :class="{ 'pdl-14': isLogin }">{{ data.delivery_note_text }}</p>
          </card-item>
          <card-item v-if="visible_bundled_flag" :label="$t('common.label.bundledFlag')">
            <p :class="{ 'pdl-14': isLogin }">{{ data.bundled_flag }}</p>
          </card-item>
        </template>
      </div>
    </the-section>
  </div>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import CardItem from './CardInfoItem.vue'
import AddressInfoItem from '@/components/AddressInfoItem.vue'

export default {
  components: { TheSection, CardItem, AddressInfoItem },
  props: {
    data: { type: Object, default: () => {} },
    businessAccountFlag: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    visible_bundled_flag() {
      return this.$store.getters['auth/shop'].visible_bundled_flag
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
    formLabelName() {
      return this.corporateFlag || !this.businessAccountFlag
        ? this.$t('common.memberInformation.fullName')
        : this.$t('common.memberInformation.companyName')
    },
    formLabelNameKana() {
      return this.corporateFlag || !this.businessAccountFlag
        ? this.$t('common.memberInformation.nameKana')
        : this.$t('common.memberInformation.companyNameKana')
    },
    hide_shipping_area() {
      return this.data.delivery_destinations_text == this.$t('common.deliveryDestination.sameMember')
    },
    isLogin() {
      return this.$store.getters[`auth/isLogin`]
    },
  },
}
</script>
